export default {
  isLock (state) {
    return state.busy === true
  }
}
